import { render, staticRenderFns } from "./wtFailedAssetCompact.vue?vue&type=template&id=f74ff06c&"
import script from "./wtFailedAssetCompact.vue?vue&type=script&lang=js&"
export * from "./wtFailedAssetCompact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports